import { API_ENDPOINT } from "@/constants/appConstants";
import { useEffect, useState } from "react";
import Lottie from "react-lottie-player";

const BasicHeader = ({
  hostname,
  isMobile,
}: {
  hostname: string;
  isMobile: boolean;
}) => {
  const [lottieUrl, setLottieUrl] = useState("");

  useEffect(() => {
    setLottieUrl(window?._siteProps_?.propertiesMap?.logoUrl || "");
  }, []);

  return (
    <header className="z-50 w-full border bg-white">
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-0 lg:w-[85%!important]">
        {lottieUrl?.includes(".json") ? (
          <Lottie
            path={lottieUrl}
            loop
            play
            style={{
              height: isMobile ? "auto" : "34px",
              width: isMobile ? "90px" : "auto",
            }}
          />
        ) : (
          <img
            src={`${API_ENDPOINT(hostname).media.founditLogo}`}
            alt="Foundit Logo"
            className="h-6"
          />
        )}
      </div>
    </header>
  );
};

export default BasicHeader;
